<template>
      <div class="dashboard-plugins">
        <div class="dashboard-plugins__chart">
          <div class="block dashboard-plugins__block">
            <div class="chart">
              <div class="chart__head">
                <div class="chart__head-info">
                  <div class="chart__title">REVENUE</div>
                  <div class="chart__value">$ 12,350.00</div>
                  <div class="chart__status chart__status--success">+9,4% since last week</div>
                </div>
                <div class="chart__head-controls">
                  <button class="button button--small button--service chart__head-controls-item"><i class="fa fa-download button__icon"></i> Export</button>
                  <button class="button button--small button--service chart__head-controls-item"><i class="fa fa-print button__icon"></i> Print</button>
                </div>
              </div>
              <div class="chart__body">
                  <chart></chart>
              </div>
            </div>
          </div>
        </div>

        <div class="dashboard-plugins__info">
          <div class="block dashboard-plugins__block">
            <slider></slider>
          </div>
        </div>

        <div class="dashboard-plugins__statistic">
          <div class="block">
            <statistics></statistics>
          </div>
        </div>
      </div>
</template>
<script>
import Chart from './plugins/chart'
import Slider from './plugins/slider'
import Statistics from './plugins/statistics'

export default {
  name: 'Dashboard',
  components: {
    Chart,
    Slider,
    Statistics
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/advertiser/dashboard.vue